import Marquee from "react-fast-marquee";

const ITEMS = [
    { text: "Be back soon", italic: false },
    { text: "Oui", italic: true },
    { text: "Something borrowed", italic: false },
    { text: "Rent · Lend · Sell", italic: true },
    { text: "Under maintenance", italic: false },
    { text: "À très vite", italic: true },
];

const Star = () => (
    <svg
        viewBox="0 0 100 100"
        className="mx-8 h-4 w-4 shrink-0 text-violet/60 md:mx-12"
        fill="currentColor"
        aria-hidden="true"
    >
        <path d="M50 0 L58 38 L95 25 L64 52 L92 82 L55 66 L50 100 L45 66 L8 82 L36 52 L5 25 L42 38 Z" />
    </svg>
);

export const EditorialMarquee = () => (
    <section
        data-testid="editorial-marquee"
        className="overflow-hidden border-y border-ink/10 bg-lavender-pale py-7 md:py-9"
    >
        <Marquee speed={28} gradient={false} pauseOnHover={false}>
            {ITEMS.map((item, i) => (
                <span key={i} className="flex items-center">
                    <span
                        className={`font-display text-3xl text-ink md:text-5xl ${
                            item.italic ? "italic text-violet" : ""
                        }`}
                    >
                        {item.text}
                    </span>
                    <Star />
                </span>
            ))}
        </Marquee>
    </section>
);
